module.exports = __webpack_public_path__ + "MG.png?729aba3fc46cd167615d7cf2be726ed6";